import React from 'react';
import { Card } from '../components/common/Card';
import { AdminAccountManagement } from '../components/admin/AdminAccountManagement';

export function AdminPage(): React.ReactElement {
  return (
    <div className="space-y-6 animate-slide-in pb-12">
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-violet-500/20 border border-violet-500/30 flex items-center justify-center text-violet-400 shrink-0">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-white tracking-tight">Admin</h1>
            <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-violet-500/10 text-violet-400 border border-violet-500/20">
              Administrator Console
            </span>
          </div>
          <p className="text-sm text-slate-400 mt-1">
            Manage user accounts and access.
          </p>
        </div>
      </div>

      {/* Main Admin Account Management Card */}
      <Card padding="md">
        <AdminAccountManagement />
      </Card>
    </div>
  );
}
